import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const axiosInstance = axios.create({
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
    },
});

export const fetchDashboardStatistics = createAsyncThunk(
    "individualSearch/fetchDashboardStatistics",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `api/IndividualSearch/GetDashboardStatistics`
            );
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                dispatch(endUserSession());
                return rejectWithValue("Session expired. Logging out.");
            }
            return rejectWithValue(error.response?.data || "Error fetching statistics.");
        }
    }
);


export const fetchIndividualRecords = createAsyncThunk(
    "individualSearch/fetchRecords",
    async ({ oneKeyId, ahpraId, firstName, lastName }, { dispatch, rejectWithValue }) => {
        try {
            const requestBody = {
                OnkeyId: oneKeyId || "",
                AhpraId: ahpraId || "",
                FirstName: firstName || "",
                LastName: lastName || "",
            };

            const response = await axiosInstance.post(
                `api/IndividualSearch/GetOnkeyRecord`,
                requestBody
            );

            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                dispatch(endUserSession());
                return rejectWithValue("Session expired. Logging out.");
            }
            return rejectWithValue(error.response?.data || "Error fetching records.");
        }
    }
);

export const queueRecordForValidation = createAsyncThunk(
    "individualSearch/queueRecordForValidation",
    async ({ record, useremail }, { dispatch, rejectWithValue }) => {
        console.log("Sending for validation in slice:", record);
        console.log("Send by user in slice: " + useremail)
        try {
            const response = await axiosInstance.post(
                `api/IndividualSearch/QueueRecord?userEmail=${useremail}`,
                record
            );
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                dispatch(endUserSession());
                return rejectWithValue("Session expired. Logging out.");
            }
            return rejectWithValue(error.response?.data || "Error queuing record for validation");
        }
    }
);

const individualSearchSlice = createSlice({
    name: "individualSearch",
    initialState: {
        records: [],
        statistics: null,
        selectedRecord: null,
        status: "idle",
        error: null,
        queueStatus: "idle",
        queueError: null,
        statisticsStatus: "idle",
        statisticsError: null,
        isSessionValid: true,
    },
    reducers: {
        setSelectedRecord: (state, action) => {
            state.selectedRecord = action.payload;
        },
        resetAPIState: (state) => {
            state.status = "idle";
            state.error = null;
            state.queueStatus = "idle";
            state.queueError = null;
        },
        endUserSession: (state) => {
            state.isSessionValid = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchIndividualRecords.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchIndividualRecords.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.records = action.payload;
            })
            .addCase(fetchIndividualRecords.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(queueRecordForValidation.pending, (state) => {
                state.queueStatus = "loading";
                state.queueError = null;
            })
            .addCase(queueRecordForValidation.fulfilled, (state) => {
                state.queueStatus = "succeeded";
            })
            .addCase(queueRecordForValidation.rejected, (state, action) => {
                state.queueStatus = "failed";
                state.queueError = action.payload;
            })
            .addCase(fetchDashboardStatistics.pending, (state) => {
                state.statisticsStatus = "loading";
            })
            .addCase(fetchDashboardStatistics.fulfilled, (state, action) => {
                state.statisticsStatus = "succeeded";
                state.statistics = action.payload;
            })
            .addCase(fetchDashboardStatistics.rejected, (state, action) => {
                state.statisticsStatus = "failed";
                state.statisticsError = action.payload;
            });
    },
});

export const { setSelectedRecord, resetAPIState, endUserSession } = individualSearchSlice.actions;
export default individualSearchSlice.reducer;
